import { render, staticRenderFns } from "./template-selector.vue?vue&type=template&id=5d47a83f"
import script from "./template-selector.vue?vue&type=script&lang=js"
export * from "./template-selector.vue?vue&type=script&lang=js"
import style0 from "./template-selector.vue?vue&type=style&index=0&id=5d47a83f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports